
define('text!templates/modules/member/group/lists/group-list.html',[],function () { return '<div class="separator">\n    <h3><span class="{{icon}}"></span> {{#t}}{{title}}{{/t}} </h3>\n</div>\n<div class="group-list"></div>\n';});

